export const MEDICAL_INSTITUTIONS_ACTIONS = {
    GET_ALL: 'GET_ALL_MEDICAL_INSTITUTIONS',
    GET_ACTIVE: 'GET_ACTIVE_MEDICAL_INSTITUTIONS',
    ADD: 'MEDICAL_INSTITUTIONS_ADD',
    FIND: 'FIND_MEDICAL_INSTITUTIONS',
    CHANGE_STATUS: 'CHANGE_STATUS_MEDICAL_INSTITUTIONS',
    SUCCESS: 'SUCCESS_MEDICAL_INSTITUTIONS',
    ERROR: 'ERROR_MEDICAL_INSTITUTIONS',
    CLEAN: 'CLEAN_MEDICAL_INSTITUTIONS',

    SUGGESTION: 'SUGGESTION_MEDICAL_INSTITUTIONS',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN_MEDICAL_INSTITUTIONS',
}